<template>
    <div>
        <vs-popup class="holamundo" icon-close="X" :title="this.title" :active.sync="active">

            <div class="table-responsive">
                <form id="add_all_charts" method="POST" :action="this.action" accept-charset="UTF-8" enctype="multipart/form-data">
                    <input type="hidden" name="_token" :value="csrf">
                    <input type="hidden" name="actor_id" :value="this.parameters.actor_id" >
                    <input type="hidden" name="workflow_id" :value="this.parameters.workflow_id"  >
                    <hr>
                        <input type="checkbox" name="checkAll" @change="actionAll($event)" :value="1" >
                        <label>Select all rows</label>
                    <hr>
                    <div>
                        <ul v-for="(group,index) in this.parameters.permissions">
                            <li>Group name: {{group.groupName}}</li>
                            <ul v-for="(question,question_id) in group.questions">
                                <li>Question name: {{question.questionName}}</li>
                                <label></label>
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th>Element name</th>
                                        <th>Not visibile</th>
                                        <th>Visibile</th>
                                        <th>Editable</th>
                                        <th>Required</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(permission,element) in question.elements">
                                        <td><input type="checkbox" class="checkButtonRow" :name="'checkQuestionPermission['+question_id+']['+element+']'" :value="1" ></td>
                                        <td>{{ element }}</td>
                                        <td><input type="radio" @change="changeValue($event)" :name="'questionPermission['+question_id+']['+element+']'" :value="0" :checked="permission == 0"></td>
                                        <td><input type="radio" @change="changeValue($event)" :name="'questionPermission['+question_id+']['+element+']'" :value="1" :checked="permission == 1"></td>
                                        <td><input type="radio" @change="changeValue($event)" :name="'questionPermission['+question_id+']['+element+']'" :value="2" :checked="permission == 2"></td>
                                        <td><input type="radio" @change="changeValue($event)" :name="'questionPermission['+question_id+']['+element+']'" :value="3" :checked="permission == 3"></td>

                                    </tr>
                                    </tbody>
                                </table>
                            </ul>
                        </ul>
                    </div>

                    <div>

                    </div>

                    <div class="col-lg-3 float-right row">

                        <div>
                            <button id="" type="button" @click="" class="btn btn-rounded btn-block btn-success"><i class="fa fa-check-circle" aria-hidden="true"></i>{{__('misc.update') }} </button>
                        </div>
                    </div>

                </form>
            </div>
        </vs-popup>
    </div>
</template>

<script>

  export default {
    // <multiselect v-model="value" :options="options"></multiselect>
    // OR register locally
    //components: { Multiselect },
    data () {
      return {
        value: null,
        editing: false,
        active: false,
        action: "",
        itemId: -1,
        title: "",
        parameters: {},
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        selectedPerson: {},
        selectedRole: {},
        errorLog    : {}

      }
    },
    methods: {
        changeValue(event){

            let v = $(event.target).val();
            let name = $(event.target).attr("name");
            let indexOf = name.indexOf('[');

            if (!$('.checkButtonRow[name="checkQuestionPermission'+name.substring(indexOf)+'"]').prop('checked')){
                return false;
            }

            $('.checkButtonRow').each(function(checkbox){

                if($(this).prop("checked")){

                    let indexOfCheck = $(this).attr("name").indexOf('[');
                    let propName = 'questionPermission'+$(this).attr("name").substring(indexOfCheck);

                    //$('.'+propName+'[value='+v+']').attr("checked",true);
                    let elem = ( "input[name='"+propName+"'][value='"+v+"']" );
                    $(elem).prop('checked',true);
                }
            });

            /**
             * function split_at_index(value, index)
             {
                 return value.substring(0, index) + "," + value.substring(index);
            }
             console.log(split_at_index('3123124', 2));
             *
             * */
            //console.log(v,name,indexOf,name.substring(indexOf));

        },
        actionAll(event){
            $('.checkButtonRow').prop("checked",event.target.checked);
        },

      toggle(action, item_id, editing, attributes) {
        this.active = true;
        this.action = action;
        this.editing = editing;
        this.itemId = item_id;
        this.title = attributes.title;
        let url = attributes.url;
        if (url!==undefined) {
          if (url.indexOf("[id]")>0) {
            url = url.replace("[id]", item_id);
          }
          axios.get(url)
              .then((response) => {
                this.parameters = response.data;
                    console.log(this.parameters);

              });
            }
        }
    },
    mounted() {
        console.log("ready");
    },
    props: {
    }

  }
</script>
